import {DialogTypes} from 'common/names';
import {SelectDialogDialogProps, SelectDialogFormType} from 'components/dialogs/SelectDialog';
import {DropdownObjectOption} from 'components/inputs/Dropdown';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {call} from 'redux-saga/effects';
import {openDialogWithResult} from 'redux/common/saga/openDialogWithResult';

export function* selectDialogSaga(title: string, label: string, options: DropdownObjectOption[]) {
   const passwordObj: ICloseSubDialogAction<SelectDialogFormType> = yield call(
      openDialogWithResult,
      {
         id: DialogTypes.SelectDialog.id,
         data: {
            title,
            label,
            options,
         } as SelectDialogDialogProps['data'],
      }
   );

   return passwordObj.payload?.data?.value;
}
